module.exports = __webpack_public_path__ + "img/ifpi-start-hero-mobile.a4c514b5.jpg";